export const translations = {
  lat: {
    appName: "Wetland Guardian",
    map: "Mapa",
    statistics: "Statistika",
    about: "O aplikaciji",
    help: "Pomoć",
    wetlandsInfo: "O vlažnim staništima",
    report: "Prijavi",
    search: "Pretraži",
    youAreHere: "Vi ste ovde",
    filters: "Filteri",
    
    // Water details
    waterDetails: "Detalji o vodi",
    wetlandType: "Tip wetland-a",
    waterClarity: "Bistrina vode",
    waterColor: "Boja vode",
    canSeeBottom: "Vidljivo dno",
    surfaceAlgae: "Alge na površini",
    waterPlants: "Vodene biljke",
    surroundingPlants: "Okolno bilje",
    
    // Wildlife
    wildlife: "Životinje",
    animalsInOrOnWater: "Životinje u ili na vodi",
    seenAnimals: "Koje životinje ste videli",
    otherSeenAnimals: "Druge životinje",
    
    // Threats
    observedThreats: "Uočene opasnosti",
    observedThreatPhotos: "Fotografije opasnosti",
    otherThreatDescription: "Opis drugih opasnosti",
    
    // Wetland types
    POND: "Bara",
    SWAMP: "Močvara",
    LAKE: "Jezero",
    SPRING: "Izvor",
    STREAM: "Potok",
    RIVER: "Reka",
    CANAL: "Kanal",
    WET_MEADOW: "Vlažna livada",
    PEAT_BOG: "Tresava",
    OXBOW_LAKE: "Mrtvaja",
    
    // Water clarity
    CLEAR: "Bistra",
    SLIGHTLY_CLOUDY: "Blago mutna",
    CLOUDY: "Mutna",
    
    // Water color
    TRANSPARENT: "Providna",
    GREEN: "Zelena",
    BROWN: "Braon",
    GRAY: "Siva",
    REDDISH: "Crvenkasta",
    BLUE: "Plava",
    YELLOW: "Žuta",
    OTHER: "Ostalo",
    
    // Yes/No options
    YES: "Da",
    NO: "Ne",
    BARELY: "Jedva",
    
    // Surface algae
    YES_FEW: "Da, malo",
    YES_MANY: "Da, mnogo",
    
    // Animals
    FISH: "Ribe",
    AMPHIBIANS: "Vodozemci",
    BIRDS: "Ptice",
    INSECTS: "Insekti",
    REPTILES: "Gmizavci",
    DROUGHT: "Drugo",
    
    // Observed threats
    CHEMICAL_POLLUTION: "Hemijsko zagađenje",
    BIOLOGICAL_POLLUTION: "Biološko zagađenje",
    INDUSTRIAL_WASTE: "Industrijski otpad",
    MUNICIPAL_WASTE: "Komunalni otpad",
    INCREASED_SEDIMENTATION: "Uvećana sedismentacija",
    DAM_OR_BARRIER_CONSTRUCTION: "Građenje brane ili barijere",
    WATER_FLOW_DIVERSION: "Preusmerenje vodotoka",
    EXCESSIVE_WATER_EXTRACTION: "Prekomerna upotreba vode",
    DECREASED_OXYGEN_LEVEL: "Smanjen nivo kiseonika",
    INVASIVE_SPECIES: "Invazivne vrste",
    FLOOD: "Poplava",
    EROSION: "Erozija",
    OVERFISHING: "Prekomerni ribolov",
    PRESENCE_OF_LEAD_SHOT: "Prisutnost olovnih zrna",
    PRESENCE_OF_RADIOACTIVE_MATERIALS: "Prisutnost radioaktivnih materijala",
    
    // Form
    submit: "Pošalji",
    cancel: "Otkaži",
    uploadPhoto: "Dodaj fotografiju",
    takePhoto: "Uslikaj",
    chooseFromGallery: "Izaberi iz galerije",
    location: "Lokacija",
    getCurrentLocation: "Uzmi trenutnu lokaciju",
    selectOnMap: "Izaberi na mapi",
    viewDetails: "Detalji",
    uploading: "Upload u toku...",
    submitting: "Slanje...",
    selectOption: "Izaberite...",
    wetlandTypePhotos: "Fotografije wetland-a",
    threatPhotosLabel: "Fotografije opasnosti",
    describeThreats: "Opišite druge opasnosti...",
    describeAnimals: "Navedite koje druge životinje ste videli...",
    successMessage: "Uspešno ste prijavili wetland! Hvala vam!",
    errorRequired: "Molimo popunite sva obavezna polja.",
    errorLocation: "Molimo dodajte lokaciju.",
    errorWetlandType: "Molimo izaberite tip wetland-a.",
    errorSubmit: "Greška pri slanju podataka. Pokušajte ponovo.",
    errorPhoto: "Greška pri upload-u fotografija. Pokušajte ponovo.",
    errorPhotoSize: "je prevelik. Maksimalna veličina je 20MB.",
    errorPhotoType: "Molimo dodajte samo fotografije.",
    errorLocation2: "Nije moguće dobiti trenutnu lokaciju. Proverite dozvole u pregledaču.",
    errorLocationNotSupported: "Geolokacija nije podržana u ovom pregledaču.",

    // Welcome modal
    welcomeTitle: "Dobro došli!",
    welcomeText1: "Dobro došli u aplikaciju ",
    welcomeText2: "! Cilj pokretanja ove aplikacije je da Srbija dobije mrežu građana i građanki naučnika koji aktivno štite njena vlažna staništa. Putem aplikacije ",
    welcomeText3: " možete beležiti i slati informacije o stanju vlažnih staništa - stanju vode, vrstama koje vidite ili opasnostima koje primetite. Na taj način učestvujete u stvaranju dragocene baze podataka koju stručnjaci sami ne bi mogli da prikupe, jer ne mogu da budu na svakom mestu u svakom trenutku. To će omogućiti da se problemi uoče na vreme, da se promene prate kroz duži period i da se odluke o zaštiti zasnivaju na stvarnim, terenskim informacijama.",
    welcomeOk: "U redu",

    dateFrom: "Datum od",
    dateTo: "Datum do",
    municipality: "Opština",
    cadastralMunicipality: "Katastarska opština",
    selectMunicipality: "Odaberite opštinu...",
    selectCadastralMunicipality: "Odaberite katastarsku opštinu...",
    selectWetlandType: "Odaberite tip wetland-a...",
    reset: "Poništi",
    searchResults: "Rezultati pretrage",
  },
  cir: {
    appName: "Wetland Guardian",
    map: "Мапа",
    statistics: "Статистика",
    about: "О апликацији",
    help: "Помоћ",
    wetlandsInfo: "О влажним стаништима",
    report: "Пријави",
    search: "Претражи",
    filters: "Филтери",
    
    // Water details
    waterDetails: "Детаљи о води",
    wetlandType: "Тип wetland-а",
    waterClarity: "Бистрина воде",
    waterColor: "Боја воде",
    canSeeBottom: "Видљиво дно",
    surfaceAlgae: "Алге на површини",
    waterPlants: "Водене биљке",
    surroundingPlants: "Okolno биље",
    
    // Wildlife
    wildlife: "Животиње",
    animalsInOrOnWater: "Животиње у или на води",
    seenAnimals: "Које животиње сте видели",
    otherSeenAnimals: "Друге животиње",
    
    // Threats
    observedThreats: "Уочене опасности",
    observedThreatPhotos: "Фотографије опасности",
    otherThreatDescription: "Опис других опасности",
    
    // Wetland types
    POND: "Бара",
    SWAMP: "Мочвара",
    LAKE: "Језеро",
    SPRING: "Извор",
    STREAM: "Поток",
    RIVER: "Река",
    CANAL: "Канал",
    WET_MEADOW: "Влажна ливада",
    PEAT_BOG: "Тресава",
    OXBOW_LAKE: "Мртваја",
    
    // Water clarity
    CLEAR: "Бистра",
    SLIGHTLY_CLOUDY: "Благо мутна",
    CLOUDY: "Мутна",
    
    // Water color
    TRANSPARENT: "Провидна",
    GREEN: "Зелена",
    BROWN: "Браон",
    GRAY: "Сива",
    REDDISH: "Црвенкаста",
    BLUE: "Плава",
    YELLOW: "Жута",
    OTHER: "Остало",
    
    // Yes/No options
    YES: "Да",
    NO: "Не",
    BARELY: "Једва",
    
    // Surface algae
    YES_FEW: "Да, мало",
    YES_MANY: "Да, много",
    
    // Animals
    FISH: "Рибе",
    AMPHIBIANS: "Водоземци",
    BIRDS: "Птице",
    INSECTS: "Инсекти",
    REPTILES: "Гмизавци",
    DROUGHT: "Друго",
    
    // Observed threats
    CHEMICAL_POLLUTION: "Хемијско загађење",
    BIOLOGICAL_POLLUTION: "Биолошко загађење",
    INDUSTRIAL_WASTE: "Индустријски отпад",
    MUNICIPAL_WASTE: "Комунални отпад",
    INCREASED_SEDIMENTATION: "Увећана седисментација",
    DAM_OR_BARRIER_CONSTRUCTION: "Грађење бране или баријере",
    WATER_FLOW_DIVERSION: "Преусмерење водотока",
    EXCESSIVE_WATER_EXTRACTION: "Прекомерна употреба воде",
    DECREASED_OXYGEN_LEVEL: "Смањен ниво кисеоника",
    INVASIVE_SPECIES: "Инвазивне врсте",
    FLOOD: "Поплава",
    EROSION: "Ерозија",
    OVERFISHING: "Прекомерни риболов",
    PRESENCE_OF_LEAD_SHOT: "Присутност оловних зрна",
    PRESENCE_OF_RADIOACTIVE_MATERIALS: "Присутност радиоактивних материјала",
    
    // Form
    submit: "Пошаљи",
    cancel: "Откажи",
    uploadPhoto: "Додај фотографију",
    takePhoto: "Усликај",
    chooseFromGallery: "Изабери из галерије",
    location: "Локација",
    getCurrentLocation: "Узми тренутну локацију",
    selectOnMap: "Изабери на мапи",
    viewDetails: "Детаљи",
    uploading: "Upload у току...",
    submitting: "Слање...",
    selectOption: "Изаберите...",
    wetlandTypePhotos: "Фотографије wetland-а",
    threatPhotosLabel: "Фотографије опасности",
    describeThreats: "Опишите друге опасности...",
    describeAnimals: "Наведите које друге животиње сте видели...",
    successMessage: "Успешно сте пријавили wetland! Хвала вам!",
    errorRequired: "Молимо попуните сва обавезна поља.",
    errorLocation: "Молимо додајте локацију.",
    errorWetlandType: "Молимо изаберите тип wetland-а.",
    errorSubmit: "Грешка при слању података. Покушајте поново.",
    errorPhoto: "Грешка при upload-у фотографија. Покушајте поново.",
    errorPhotoSize: "је превелик. Максимална величина је 20MB.",
    errorPhotoType: "Молимо додајте само фотографије.",
    errorLocation2: "Није могуће добити тренутну локацију. Проверите дозволе у прегледачу.",
    errorLocationNotSupported: "Геолокација није подржана у овом прегледачу.",

  }
};

